import type { RouteLocationRaw } from 'vue-router'
import type { AuthStatus } from '@/stores/auth'

export interface GuardInput {
  status: AuthStatus
  isAdmin: boolean
  insideTelegram: boolean
  to: {
    name: unknown
    fullPath: string
    redirect: unknown
    isPublic: boolean
    requiresAdmin: boolean
  }
}

// A `?redirect=` is only followed when it is a path of this app.
export function safeRedirect(redirect: unknown): string | null {
  return typeof redirect === 'string' && redirect.startsWith('/') && !redirect.startsWith('//') ? redirect : null
}

// Where a navigation has to go instead, or `undefined` to let it through. Signed in: the entry pages (`/`, sign-in and
// landing page) lead on to the todos. Signed out: `/` shows the landing page, public routes stay open, a plain browser
// that could not sign in (`/auth` in the error state) gets the landing page with its log in button, everything else
// goes to `/auth` and back afterwards.
export function guardRedirect({ status, isAdmin, insideTelegram, to }: GuardInput): RouteLocationRaw | undefined {
  const redirect = safeRedirect(to.redirect)
  if (status === 'authenticated') {
    if (to.name === 'auth' || to.name === 'landing') return redirect ?? '/todos'
    if (to.name === 'home') return '/todos'
    if (to.requiresAdmin && !isAdmin) return { path: '/todos' }
    return undefined
  }
  if (to.name === 'home') return { path: '/welcome' }
  if (to.isPublic) return undefined
  if (to.name === 'auth') {
    if (!insideTelegram && status === 'error') {
      return redirect ? { path: '/welcome', query: { redirect } } : { path: '/welcome' }
    }
    return undefined
  }
  return { path: '/auth', query: { redirect: to.fullPath } }
}
